import { useState } from "react";
import { Sparkles, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { aiSearch } from "../lib/api";

export default function AiSearchBar({ onResults, onClear }) {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [rationale, setRationale] = useState("");

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!q.trim()) return;
    setLoading(true);
    try {
      const data = await aiSearch(q.trim());
      setResults(data.entries || []);
      setRationale(data.rationale || "");
      onResults?.(data.entries || []);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "AI search failed");
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setQ("");
    setResults(null);
    setRationale("");
    onClear?.();
  };

  return (
    <div className="mb-6 border border-white/15 bg-neutral-950">
      <form onSubmit={submit} className="flex items-center gap-3 px-4 py-3">
        <Sparkles className="h-4 w-4 flex-shrink-0 text-[#FF3B30]" />
        <input
          data-testid="ai-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Ask anything: 'cozy shows like Frieren', 'stuff under 12 episodes', 'action I rated 9+'"
          className="flex-1 bg-transparent py-1 text-sm text-white placeholder:text-neutral-600 focus:outline-none"
        />
        {results != null && (
          <button
            data-testid="ai-search-clear"
            type="button"
            onClick={clear}
            className="border border-white/15 p-1 text-neutral-400 hover:bg-white hover:text-black"
          >
            <X className="h-3 w-3" />
          </button>
        )}
        <button
          data-testid="ai-search-submit"
          type="submit"
          disabled={loading}
          className="border border-white/15 bg-[#FF3B30] px-4 py-2 font-mono text-[10px] uppercase tracking-widest text-white hover:bg-[#D62828] disabled:opacity-50"
        >
          {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : "Ask"}
        </button>
      </form>
      {(rationale || results != null) && (
        <div className="border-t border-white/10 bg-black/40 px-4 py-3">
          <p className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
            <span className="text-[#FF3B30]">AI: </span>
            {rationale || `${results.length} match${results.length === 1 ? "" : "es"}`}
          </p>
        </div>
      )}
    </div>
  );
}
